import React, { useMemo, useState } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';

import { useNewRefuel } from '../../../../../hooks/useNewRefuel';

import {
  TooltipContainer,
  TooltipIcon,
  TooltipContent,
  Title,
  Text,
  TooltipArrow,
} from './styles';

const TooltipHeader: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  const { enabledStep } = useNewRefuel();

  const toggleTooltip = (): void => {
    setIsVisible(!isVisible);
  };

  const contentTooltip = useMemo(() => {
    if (enabledStep === 2) {
      return {
        title: 'Nível do gás',
        text: 'Mantenha seu estoque de gás em 80% para evitar imprevistos e garantir a continuidade das operações do seu negócio.',
      };
    }
    if (enabledStep === 3) {
      return {
        title: 'Horário de entrega',
        text: 'O abastecimento do seu estabelecimento ocorrerá o mais próximo possível do horário cadastrado em Melhores horários. No entanto, podem ocorrer imprevistos.',
      };
    }
    if (enabledStep === 4) {
      return {
        title: 'Quem poderá receber?',
        text: 'Visando a segurança a central de GLP deve ser operada e supervisionada por uma pessoa com idade mínima de 18 anos.',
      };
    }
    if (enabledStep === 5) {
      return {
        title: 'Ajude-nos a prevenir acidentes!',
        text: 'Mantenha a área da central de gás livre de materiais inflamáveis (madeira, papel, tintas, etc.).',
      };
    }
    return null;
  }, [enabledStep]);

  return (
    <TooltipContainer>
      <TooltipIcon onClick={toggleTooltip}>
        <AiOutlineWarning size={24} color="#F5A623" />
      </TooltipIcon>
      {isVisible && contentTooltip && (
        <TooltipContent>
          <TooltipArrow />
          <Title>{contentTooltip?.title}</Title>
          <Text>{contentTooltip?.text}</Text>
        </TooltipContent>
      )}
    </TooltipContainer>
  );
};

export default TooltipHeader;
